import React from "react";

import "./ReferenceLayers.scss";
import ReferenceLayerItem from "./ReferenceLayerItem/ReferenceLayerItem";
import { RefLayers } from "./ReferenceLayersConfig";

function ReferenceLayers(props) {
  const {
    layersToInclude,
    layersEnabled,
    handleLayerToggle,
    isRadio,
    countries,
  } = props;

  const getUrls = (layer) => {
    const keys = Object.keys(RefLayers).filter((l) => l.indexOf(layer.layer) > -1);
    return keys.map((key) => RefLayers[key]);
  };

  return (
    <div className="referenceLayers" name="referenceLayers">
      {layersToInclude.map((layer) => (
        <ReferenceLayerItem
          key={layer.layer}
          info={layer}
          handleLayerToggle={handleLayerToggle}
          layer={layer.layer}
          isRadio={isRadio}
          countries={countries}
          isMultiLayered={layer.isMulti}
          urls={layer.isMulti ? getUrls(layer) : null}
          url={layer.url || RefLayers[layer.layer]}
          isVisible={layersEnabled.includes(layer.layer)}
        />
      ))}
    </div>
  );
}

export default ReferenceLayers;
